import React, { useId } from 'react'
import PropTypes from 'prop-types'

const NoteLockIcon = React.forwardRef(function NoteLockIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M19 14C16.79 14 15 15.79 15 18V19 23C15 23.55 15.45 24 16 24H22C22.55 24 23 23.55 23 23V19 18C23 15.79 21.21 14 19 14ZM19 16C20.1 16 21 16.9 21 18H17C17 16.9 17.9 16 19 16ZM2 12C2.55 12 3 11.55 3 11V6C3 4.35 4.35 3 6 3H11C11.55 3 12 2.55 12 2 12 1.45 11.55 1 11 1H6C3.24 1 1 3.24 1 6V11C1 11.55 1.45 12 2 12ZM12 21H11 10.19C9.64 21 9.19 21.45 9.19 22 9.19 22.55 9.64 23 10.19 23H11 12C12.55 23 13 22.55 13 22 13 21.45 12.55 21 12 21ZM22 9C21.45 9 21 9.45 21 10V11 12C21 12.55 21.45 13 22 13 22.55 13 23 12.55 23 12V11 10C23 9.45 22.55 9 22 9ZM17.81 8.29 15.81 6.29C15.42 5.9 14.79 5.9 14.4 6.29L2.4 18.29C2.29 18.4 2.21 18.53 2.16 18.68L1.16 21.68C1.04 22.04 1.13 22.44 1.4 22.7 1.59 22.9 1.85 23 2.11 23 2.22 23 2.32 22.98 2.43 22.95L5.43 21.95C5.58 21.9 5.71 21.82 5.82 21.71L17.82 9.71C18.2 9.32 18.2 8.68 17.81 8.29ZM19.34 6.71C19.54 6.9 19.79 7 20.05 7 20.3 7 20.54 6.91 20.74 6.73L21.81 5.71C23.31 4.21 23.5 2.87 22.37 1.74 21.81 1.18 21.19.940001 20.52 1.03 19.85 1.11 19.17 1.52 18.37 2.32L17.37 3.37C17 3.76 17 4.38 17.39 4.77L19.34 6.71Z"></path>
    </svg>
  )
})

NoteLockIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

NoteLockIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default NoteLockIcon
